<div *ngIf="status && status.logged_in else loginTemplate">
  Account: {{ status.account_name }} ({{ status.account_type }})
  <button class="btn btn-sm btn-secondary" (click)="logout()">Logout</button>

  <div *ngIf="videos" class="mt-2">
    <div style="display: flex; margin-bottom: 10px; display: flex; align-items: center; margin-bottom: 10px">
      <a *ngIf="selectedFolder" (click)="selectedFolder = null" class="mr-3" style="cursor: pointer">
        <fa-icon icon="arrow-circle-up" size="2x"></fa-icon>
      </a>
      <div class="path">/{{ selectedFolder }}</div>
      <div class="ms-2 btn-group btn-group-sm" role="group">
        <button *ngIf="!selectedFolder" class="ml-3 btn btn-success btn-sm" (click)="addFolder()">
          <fa-icon icon="plus-circle"></fa-icon>
          Add Folder
        </button>
        <button *ngIf="edit && selectedVideos.length" class="btn btn-danger btn-sm" (click)="massDelete();$event.stopPropagation()">
          Delete All
        </button>
        <button *ngIf="edit" class="btn btn-primary btn-sm" (click)="massUpdateWhitelist();$event.stopPropagation()">
          Update All Whitelists
        </button>
        <button *ngIf="edit" class="btn btn-primary btn-sm" (click)="massUpdateThumbnails();$event.stopPropagation()">
          Update All Thumbnails
        </button>
      </div>
    </div>
    <div>
      <ngb-progressbar *ngIf="progress != null" type="success" [value]="progress" [max]="1"></ngb-progressbar>
    </div>
    <div
      class="d-flex align-items-center p-3"
      *ngFor="let v of currentVideos"
      (click)="select(v)"
      [class.bg-secondary]="selected?.name == v.name || selectedVideos.includes(v.id)"
      [class.text-white]="selected?.name == v.name || selectedVideos.includes(v.id)"
    >
      <div class="flex-shrink-0 mr-3 w-25 video-image-container">
        <img *ngIf="v.type === 'file'" class="img-fluid" [src]="v.image" />
        <fa-icon class="icon" *ngIf="v.type === 'folder'" icon="folder"></fa-icon>
        <div *ngIf="edit && v.type === 'file'" class="overlay" (click)="thumbnail(v)">
          <span>
            <fa-icon icon="pencil"></fa-icon>
          </span>
        </div>
      </div>
      <div class="flex-grow-1 ms-3">
        <app-pencil-input
          class="mb-4"
          [disabled]="!edit || v.type !== 'file'"
          [(input)]="v.name"
          (submit)="update(v)"
          [name]="'input-' + v.id"
        >
          <h4 [class.text-white]="selected?.name == v.name || selectedVideos.includes(v.id)" class="m-0">
            {{ v.name }} <span *ngIf="v.type === 'file' && v.transcode !== 'complete'">(transcoding)</span>
          </h4>
        </app-pencil-input>

        <div class="mt-2 btn-group btn-group-sm" role="group">
          <button *ngIf="edit && v.type === 'file'" class="btn btn-primary btn-sm" (click)="move(v);$event.stopPropagation()">Move</button>
          <button *ngIf="edit" class="btn btn-danger btn-sm" (click)="delete(v);$event.stopPropagation()">Delete</button>
          <button *ngIf="v.type === 'file'" class="btn btn-primary btn-sm" (click)="updateWhitelist(v);$event.stopPropagation()">
            Update Whitelist
          </button>
        </div>

        <div *ngIf="v.domains">
          Valid Apps:
          <div *ngFor="let d of v.domains">{{ d }}</div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <app-file-upload
      [(uploadProgress)]="uploadProgress"
      [(uploading)]="uploading"
      (upload)="upload($event)"
      [fileTypes]="fileTypes"
      [multiple]="true"
      [confirm]="true"
    ></app-file-upload>
  </div>
</div>

<ng-template #loginTemplate>
  <a *ngIf="authLink" role="button" class="btn btn-sm btn-primary" [href]="authLink">Login</a>
</ng-template>

<input
  style="display: none"
  type="file"
  name="thumbnailInput"
  id="thumbnailInput"
  accept="image/jpg, image/png, image/gif"
  #thumbnailInput
/>

<ng-template #createFolderModal let-modal>
  <div class="modal-header justify-content-center">
    <h4 class="title title-up">Create Folder</h4>
  </div>
  <div class="modal-body">
    <input class="form-control w-100" type="text" placeholder="Folder name" [(ngModel)]="folder" name="folder-name" />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm mx-3" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-sm mx-3 btn-primary" (click)="modal.close(folder)">Create</button>
  </div>
</ng-template>

<ng-template #moveModal let-modal>
  <div class="modal-header justify-content-center">
    <h4 class="title title-up">Select Folder</h4>
  </div>
  <div class="modal-body">
    <select class="custom-select" [(ngModel)]="folder">
      <option *ngFor="let f of folders; let i = index" [value]="i">{{f.name}}</option>
    </select>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-sm mx-3" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-sm mx-3 btn-primary" (click)="modal.close(folder)">Select</button>
  </div>
</ng-template>
